export const API_URL = '/api/knowledge-base'
export const URL_PREFIX = '/knowledge-base'

export const SEARCH_MIN_QUERY_LENGTH = 3
export const SEARCH_QUERY_PARAM = 'phrase'
